// Module
var code = "<protective-equipment-test-reports-grid on-select=\"onEquipmentTestSelected($event)\"></protective-equipment-test-reports-grid>\n";
// Exports
module.exports = code;